// extracted by mini-css-extract-plugin
module.exports = {"show":"index__show__xp8nc","btnBox":"index__btnBox__NaxbY","btn":"index__btn__OZXK3"};